import { ToastColorEnum } from '@sancare/typescript-commons/src/components/types'
import { AbstractState } from '@sancare/typescript-commons/src/store/types'

export class ToastState extends AbstractState {
  color: ToastColorEnum = ToastColorEnum.NONE
  isOpen = false
  message = ''
  title = ''
}
